import { MapValue } from "./types";

export const getImgUrlFor = (url: string) => {
  return url?.indexOf("://") !== -1 ? url : `${url}`;
};

export const getPins = (value: MapValue) => {
  return value?.pins || [];
};
